import { render, staticRenderFns } from "./st2.vue?vue&type=template&id=5c2565a6"
import script from "./st2.vue?vue&type=script&lang=js"
export * from "./st2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports